import React from "react";
import NumberFormat from "react-number-format";

export const AlmacenesTable = ({ almacenes = [], handleChange = () => {} }) => {
    return (
        <div className="new-table-wrapper inventario-inicial__table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th rowSpan={2}>Almacén</th>
                        <th rowSpan={2} className="cell-border-right">
                            Tipo de materia prima
                        </th>
                        <th colSpan={2}>Primer inventario</th>
                    </tr>
                    <tr>
                        <th>Kg secos laboratorio</th>
                        <th>Kg secos liquidación</th>
                    </tr>
                </thead>
                <tbody>
                    {almacenes.length === 0 && (
                        <tr>
                            <td colSpan={4} className="text-center">
                                No hay almacenes disponibles.
                            </td>
                        </tr>
                    )}
                    {almacenes.map((item) => {
                        return (
                            <tr
                                key={item.almacen_id}
                                className={
                                    item._dirty ? "bg-warning-light" : ""
                                }
                            >
                                <td className="text-center text-nowrap">
                                    {item.nombre_almacen}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.materia_prima}
                                </td>
                                <td className="text-center text-nowrap">
                                    <div
                                        className="mx-auto"
                                        style={{ maxWidth: "120px" }}
                                    >
                                        <NumberFormat
                                            className="form-control"
                                            value={item.kg_secos_laboratorio || ""}
                                            suffix=" Kg"
                                            thousandSeparator=","
                                            onValueChange={(values) => {
                                                handleChange(
                                                    item.almacen_id,
                                                    "kg_secos_laboratorio",
                                                    values.floatValue || 0,
                                                );
                                            }}
                                            placeholder="0 kg"
                                            decimalScale={3}
                                            allowNegative={false}
                                        />
                                    </div>
                                </td>
                                <td className="text-center text-nowrap">
                                    <div
                                        className="mx-auto"
                                        style={{ maxWidth: "120px" }}
                                    >
                                        <NumberFormat
                                            className="form-control"
                                            value={item.kg_secos_liquidacion || ""}
                                            suffix=" Kg"
                                            thousandSeparator=","
                                            onValueChange={(values) => {
                                                handleChange(
                                                    item.almacen_id,
                                                    "kg_secos_liquidacion",
                                                    values.floatValue || 0,
                                                );
                                            }}
                                            placeholder="0 kg"
                                            decimalScale={3}
                                            allowNegative={false}
                                        />
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
